import React from 'react';

const CalendariFrame = () => {

  return (
    <div className="flex flex-col items-center my-8">
      <h2 className="font-heading text-2xl font-bold mb-4">Livermore Lodge 219's Public Event Calendar</h2>
        <div className="relative w-full max-w-4xl" style={{ paddingBottom: "75%" }}>
            <iframe 
                src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FLos_Angeles&showPrint=0&src=Y19mYmM2NTI1ZThiMGJkNDk2ODE5N2IwOGM4YWRjYTA3MGZhYWMzNmMxZmUyZmJhMjUwZTk1NzczYjZhYmEyNjkwQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&color=%233f51b5"  
                width="800" 
                height="600" 
                style={{ border: 0, position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                frameborder="0">
            </iframe>
        </div>
    </div>
  )
}

export default CalendariFrame;